import { render, staticRenderFns } from "./BatteryNotification.vue?vue&type=template&id=4a74cc8e&"
import script from "./BatteryNotification.vue?vue&type=script&lang=js&"
export * from "./BatteryNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports